export const UNIT_ORDER = ["", "万", "億", "兆", "京", "垓", "極"];

export function formatMubouScore(goal) {
  if (!goal) return "AI判定中";
  if (goal.display_score) return goal.display_score;

  const rawScore = goal.ai_score ?? goal.score;
  if (rawScore == null || rawScore === "") return "AI判定中";

  const score = Number(rawScore);
  if (Number.isNaN(score)) return "AI判定中";

  const unit = goal.ai_unit ?? goal.unit ?? "";
  return `${score}${unit || ""}%`;
}

export function getScoreMagnitude(goal) {
  if (!goal) return -1;
  const rawScore = goal.ai_score ?? goal.score;
  const score = Number(rawScore) || 0;
  const unit = goal.ai_unit ?? goal.unit ?? "";
  const unitIndex = UNIT_ORDER.indexOf(unit);
  const safeUnitIndex = unitIndex >= 0 ? unitIndex : 0;
  return safeUnitIndex * 1000000 + score;
}
